import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {TypedAddress, typedAddressModelFactory} from "../../address/address.model";
import {SiteService} from "../../sites/site.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {NgForm} from "@angular/forms";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {SiteDetailModel, siteDetailModelFactory} from "../../sites/site-detail.model";
import {ProjectService} from "../../project/project.service";

@Component({
  templateUrl: "./set-site-address.template.pug",
  providers: [
    SiteService,
    ProjectService,
  ],
})
export class SetSiteAddressComponent extends WorkflowStep {
  projectId: string;
  siteId: string;
  site: SiteDetailModel = siteDetailModelFactory();
  projectCountry: any = {};
  originalHpInstalledKitFlag = true;
  siteAddress: TypedAddress = typedAddressModelFactory({});
  consumableAddress: TypedAddress = typedAddressModelFactory({});
  serviceAddress: TypedAddress = typedAddressModelFactory({});
  error: Error;

  @ViewChild("siteAddressForm")
  public siteAddressForm: NgForm;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private siteService: SiteService,
    private projectService: ProjectService,
  ) {
    super(true);
  }

  checkDirty(): boolean {
    return this.siteAddressForm.dirty;
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    const addresses = [{...this.siteAddress}, {...this.consumableAddress}, {...this.serviceAddress}];

    if (this.originalHpInstalledKitFlag !== this.site.hpInstalledKit) {
      await this.siteService.saveSite(this.site);
    }

    await this.siteService.setAddresses(this.siteId, addresses);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.siteId = workflowTargetInfo.targetId;
    this.projectId = workflowTargetInfo.projectId;
    this.site = await this.siteService.getSiteById(this.siteId);
    this.projectCountry = await this.projectService.getProjectCountry(workflowTargetInfo.projectId);
    this.originalHpInstalledKitFlag = this.site.hpInstalledKit;

    const addresses = await this.siteService.getAddresses(this.siteId, ["site", "site_toner", "site_service"]);

    addresses.forEach((item) => {
      this[item.type]["type"] = item.type;
      this[item.type]["address"] = item.address;
    });
  }
}
